module.exports = __webpack_public_path__ + "static/assets/0bd32feab34717d83b8edcf777c81a63.png";